























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ChartNum extends Vue {
  @Prop() private data!: any;
  @Prop() private i!: any;
  @Prop() private intervalTime!: any;
  get avg() {
    const data = this.data[Object.keys(this.data)[0]].filter((i: number) => i > 0 );
    return data.reduce((acc: number, val: number) => acc + val, 0) / data.length;
  }
  get unit() {
    let unit = 'ms' as string | null;
    if (
      this.i.d === 'databaseThroughput' ||
      this.i.d === 'serviceThroughput' ||
      this.i.d === 'instanceThroughput' ||
      this.i.d === 'endpointThroughput'
    ) {
      unit = 'cpm';
    }
    if (
      this.i.d === 'databaseSLA' ||
      this.i.d === 'serviceSLA' ||
      this.i.d === 'instanceSLA' ||
      this.i.d === 'endpointSLA'
    ) {
      unit = '%';
    }
    if (this.i.d === 'serviceApdexScore') {
      unit = null;
    }
    return unit;
  }
}
